/**
 * ч.1126: панель платформи — посилання для тестувальників і тестові акаунти.
 * Лише власник платформи з входом, підтвердженим кодом.
 */
import { api } from './client';

export interface TesterLink {
  id: string;
  note: string;
  max_uses: number | null;
  used_count: number;
  expires_at: string | null;
  revoked_at: string | null;
  created_at: string;
  /** Чи можна ще зареєструватися за посиланням (не відкликане, не спливло, не вичерпане). */
  usable: boolean;
}

export interface TesterTenant {
  id: string;
  name: string;
  is_tester: boolean;
  created_at: string;
  link_note: string | null;
  organizations: number;
  owners: string | null;
}

export interface TestersOverview {
  links: TesterLink[];
  tenants: TesterTenant[];
}

const SILENT = { headers: { 'X-Silent-Toast': '1' } };

export const platformTesters = {
  overview: () => api.get<TestersOverview>('/platform/testers').then((r) => r.data),
  /** Нове посилання. Адресу з кодом сервер віддає лише тут, один раз. */
  createLink: (body: { note: string; max_uses: number | null; valid_days: number | null }) =>
    api.post<{ id: string; url: string }>('/platform/testers/links', body, SILENT).then((r) => r.data),
  revokeLink: (id: string) =>
    api.post('/platform/testers/links/revoke', { id }, SILENT).then((r) => r.data),
  setTenantTester: (tenantId: string, isTester: boolean) =>
    api.post('/platform/testers/tenants', { tenant_id: tenantId, is_tester: isTester }, SILENT)
      .then((r) => r.data),
};
